export default "__VITE_ASSET__kpN_g4Me__"